import React, { useEffect, useState } from "react";
import SisLoader from "../../../../widgets/loader";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import PurifierDetailsTable from "../components/PurifierRow";

function StaffShipPurifierDetails({ id }) {
  const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const fetchPurifierList = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("ship_id", id);

    try {
      const res = await post(ApiURL.list_ship_purifier_details_st, formData);
      if (res?.status === true) {
        setFilteredData(res?.response_data || []);
      }
    } catch (error) {
      console.error("Error fetching purifier list:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchPurifierList();
  }, []);

  return (
    <>
      <h3 style={{ margin: "15px 0", fontWeight: "600" }}>Purifier Information</h3>
      {loader ? (
        <SisLoader />
      ) : filteredData.length > 0 ? (
        <PurifierDetailsTable data={filteredData} />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default StaffShipPurifierDetails;
